/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { logger } from '~/utils/sentry/client-only-logger'
import { analytics } from './segment-analytics'
import { withPrefix, PAGE_EVENT_TIMEOUT_MS } from './utils'

/**
 * Tracks page load / page view events
 */
const trackPage = (title: string): void => {
  setTimeout(() => {
    const name = withPrefix(title)
    // if we send event name, in Mixpanel we get two events instead of one:
    // Page loaded + Page viewed
    analytics.page(undefined, { name }).catch((e: unknown) => {
      logger.error(e)
    })
    // Without the timeout,
    // Nuxt sometimes does not have enough time to update path, title, etc.
    // and sends the data of the previous page
  }, PAGE_EVENT_TIMEOUT_MS)
}

export const useTrackPage = (title: string) =>
  clientOnly(() => {
    trackPage(title)
  })
